export default "__VITE_ASSET__BVNbYb67__"